import { render, staticRenderFns } from "./OpsCollectionsItem.vue?vue&type=template&id=be8aec30&"
import script from "./OpsCollectionsItem.vue?vue&type=script&lang=js&"
export * from "./OpsCollectionsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports